<template>
  <div class="wrapper" @click="hideDropmenu($event)">
    <div class="company-top">
      <div class="search-header">
        <div class="search-header-text">{{ company.shortname }}({{ companycode }})</div> 
        <div class="Quarterly-menu">   
          <div class="head-title" @click.top="toggleDropdown"> 
            {{ selectTab | fomartTab }} 
            <span class="close-bot"></span>
          </div>
          <ul class="menu-lanmu" v-if="showDropdownMenu">  
            <li v-for="(key, val) in tabList">
              <a href="javascript:;" v-if="key !== selectTab" @click.stop="setSelectTab(key)">{{ val }}</a>
            </li>
          </ul>
        </div> 
      </div> 
      <div class="cop-header-menu" style="overflow-x: scroll; overflow-y: hidden;" v-if="stype != 6">
        <!-- 公司资料 -->
        <ul v-if="selectedTab === 'baseinfo'">
          <li :class="{ 'on': selectedTab2 == 1 }" @click="setSelectTab2(1)">基本信息</li>
          <li :class="{ 'on': selectedTab2 == 2 }" @click="setSelectTab2(2)">高管</li> 
        </ul>

        <!-- 股东 -->
        <ul v-if="selectedTab === 'gudong'">
          <li :class="{ 'on': selectedTab2 == 1 }" @click="setSelectTab2(1)">机构持仓</li>
          <li :class="{ 'on': selectedTab2 == 2 }" @click="setSelectTab2(2)">十大股东</li> 
          <li :class="{ 'on': selectedTab2 == 3 }" @click="setSelectTab2(3)">重要股东股权变动</li> 
        </ul>

        <!-- 财务分析 -->
        <ul v-if="selectedTab === 'finance'" style="display: inline-flex;">
          <li :class="{ 'on': selectedTab2 == 1 }" @click="setSelectTab2(1)">公司综合能力指标</li>
          <li :class="{ 'on': selectedTab2 == 2 }" @click="setSelectTab2(2)">负债表</li> 
          <li :class="{ 'on': selectedTab2 == 3 }" @click="setSelectTab2(3)">利润表</li> 
          <li :class="{ 'on': selectedTab2 == 4 }" @click="setSelectTab2(4)">流量表</li>
          <li :class="{ 'on': selectedTab2 == 5 }" @click="setSelectTab2(5)">业绩预告</li> 
          <li :class="{ 'on': selectedTab2 == 6 }" @click="setSelectTab2(6)">行业对比</li> 
        </ul>

        <!-- 主营业务 -->
        <ul v-if="selectedTab === 'mainbusiness'">
          <li :class="{ 'on': selectedTab2 == 1 }" @click="setSelectTab2(1)">按产品</li>
          <li :class="{ 'on': selectedTab2 == 2 }" @click="setSelectTab2(2)">按行业</li> 
          <li :class="{ 'on': selectedTab2 == 3 }" @click="setSelectTab2(3)">按地域</li> 
        </ul>

        <!-- 客户与供应商 -->
        <ul v-if="selectedTab === 'customersandsuppliers'">
          <li :class="{ 'on': selectedTab2 == 1 }" @click="setSelectTab2(1)">客户信息</li>
          <li :class="{ 'on': selectedTab2 == 2 }" @click="setSelectTab2(2)">供应商信息</li> 
        </ul>

        <!-- 交易信息 -->
        <ul v-if="selectedTab === 'tradinginformation'">
          <li :class="{ 'on': selectedTab2 == 1 }" @click="setSelectTab2(1)">交易行情</li>
          <li :class="{ 'on': selectedTab2 == 2 }" @click="setSelectTab2(2)">龙虎榜</li> 
          <li :class="{ 'on': selectedTab2 == 3 }" @click="setSelectTab2(3)">大宗交易</li> 
        </ul>


      </div>


      <!-- 港股 -->
      <div class="cop-header-menu" style="overflow-x: scroll; overflow-y: hidden;" v-if="stype == 6">
        <!-- 公司资料 -->
        <ul v-if="selectedTab === 'baseinfo'">
          <li :class="{ 'on': selectedTab2 == 1 }" @click="setSelectTab2(1)">基本信息</li>
          <li :class="{ 'on': selectedTab2 == 2 }" @click="setSelectTab2(2)">高管</li> 
        </ul>

        <!-- 股东 -->
        <ul v-if="selectedTab === 'gudong'">
          <li :class="{ 'on': selectedTab2 == 2 }" @click="setSelectTab2(2)">十大股东</li> 
        </ul>

        <!-- 财务分析 -->
        <ul v-if="selectedTab === 'finance'" style="display: inline-flex;">
          <li :class="{ 'on': selectedTab2 == 2 }" @click="setSelectTab2(2)">负债表</li> 
          <li :class="{ 'on': selectedTab2 == 3 }" @click="setSelectTab2(3)">利润表</li> 
          <li :class="{ 'on': selectedTab2 == 4 }" @click="setSelectTab2(4)">流量表</li>
        </ul>
      </div>  
    </div>

    <!-- <router-view :companyDetail="company"></router-view>  -->
    <router-view></router-view> 
  </div>
</template>

<script>
  import { alert, apiUrl, downloadURL } from '../../helper'
  import $ from 'jquery'
  import userMix from '../../common/userMix'
  import searchMix from '../../common/searchMix'
  import comSearchMix from '../../common/comSearchMix'
  import companyMix from '../../common/companyMix'
  import wxshareMix from '../../common/wxshareMix'

  export default {
    mixins: [userMix, searchMix, comSearchMix, companyMix, wxshareMix],
    data () {
      return {
        company: {}
      }
    },
    ready() {
      this.$nextTick(() => {
        this.divMinHeight('.wrapper');
      });
    },
    route: {
      data({to}) {
        console.log("App.vue to detail")
        console.log("初始化接收公司代码")
        console.log(to.query.companycode)
        console.log(to)
        this.queryParam = to.query;
        this.companycode = to.query.companycode;
        this.stype = to.query.stype;
        if(this.stype == 6){
          this.tabList = this.tabListH;
        }

        // if (!this.currentuser) {
        //   this.wxcode = this.getQueryString('code')  // 获取微信登录code
        //   if (this.wxcode) {
        //     this.wxlogin(this.wxcode)
        //   } else {
        //     this.getProfile(to.query.share)
        //   }
        // }

        // if (this.currentuser) {         
          this.detail();
          // console.log(this.company)
          // console.log('detail 异步 未结束 --------------------进入companyMix')
          this.setSelectedTab();
        // }

      }
    },
    methods: {
      // 公司信息页
      detail: function () {
        // console.log('渲染detail函数')
        this.loading = true;
        $.ajax({
          url: apiUrl('/V1.0.0/company/detail'),
          method: 'post',
          dataType: 'json',
          // async: false,
          data: JSON.stringify({'code': this.companycode})
        }).done((response) => {
          // console.log('渲染detail')
          this.loading = false;
          if (response.status === 0) {
            this.company = response.data
            // console.log('输出company')
            // console.log(this.company)
            // this.legendCompany.push(this.company.shortname)

            // if (this.company.executives.length > 0) {
            //   for (let i of this.company.executives) {
            //     if (i.category === 1) {
            //       this.directorNum++
            //     } else if (i.category === 2) {
            //       this.SupervisorsNum++
            //     } else {
            //       this.ExecutiveNum++
            //     }
            //   }
            // }

          } else {
            console.log( response.description );
          }
        }).fail((response) => {
          this.loading = false;
          alert('请求失败')
        })
      },
      toggleDropdown() {
        this.showDropdownMenu = this.showDropdownMenu ? false : true;
      },
      // min height
      divMinHeight: function(className) {
        this.$nextTick(function() {
          $(className).css({'min-height': $(window).height()});
        });
      },
    }
  }
</script>

<style scoped>
</style>


/** WEBPACK FOOTER **
 ** App.vue?13300e64
 **/